import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isNew: true,
  isDataChanged: false,
  reload: false,
  data: {
    firstName: "",
    lastName: "",
    gender: 0,
    birthDate: "",
    nationalCode: "",
    isSayed: false,
    birthCountryId: undefined,
    birthProvinceId: undefined,
    birthCityId: undefined,
    residenceMobileNumber: "",
    residenceLandNumber: "",
    residenceEmail: "",
    residenceCountryId: undefined,
    residenceProvinceId: undefined,
    residenceCityId: undefined,
    residenceRegionId: undefined,
    residenceAddress: "",
    residenceLatitude: 0,
    residenceLongitude: 0,
    residenceZoom: 0,
    livingAlone: true,
    hasDorm: false,
    familyMobileNumber: "",
    familyLandNumber: "",
    familyCountryId: undefined,
    familyProvinceId: undefined,
    familyCityId: undefined,
    familyRegionId: undefined,
    familyAddress: "",
    familyLatitude: 0,
    familyLongitude: 0,
    familyZoom: 0,
    birthCityOther: "",
    birthProvinceOther: "",
    residenceCityOther: "",
    residenceProvinceOther: "",
    familyProvinceOther: "",
    familyCityOther: "",
  },
};

export const BasicInformationSlice = createSlice({
  name: "BasicInformation",
  initialState,
  reducers: {
    updateBasicInformationData: (state, { payload: { key, value, required } }) => {
      state.isDataChanged = true;
      state.data[key] = value;
      if (value.length === 0) {
        if (required) {
          state.data[key] = value;
        } else {
          delete state.data[key];
        }
      } else {
        state.data[key] = value;
      }
    },
    setIsDataChangedForBasic: (state, { payload }) => {
      state.isDataChanged = payload;
    },
    setIsNewForBasicInformation: (state, { payload }) => {
      state.isNew = payload;
    },
    setBasicInformationData: (state, { payload }) => {
      state.isNew = false;
      state.isDataChanged = false;
      state.data = payload;
    },
    clearBasicInformationData: () => initialState,
    setReloadBasicInformationData: (state, { payload }) => {
      state.reload = payload;
    },
  },
});

export const {
  setIsDataChangedForBasic,
  setIsNewForBasicInformation,
  setBasicInformationData,
  updateBasicInformationData,
  clearBasicInformationData,
  setReloadBasicInformationData,
} = BasicInformationSlice.actions;

export const BasicInformationReducer = BasicInformationSlice.reducer;
